'use strict';

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Hoek = require('@hapi/hoek');

var Any = require('../any');

var internals = {};

internals.Lazy = /*#__PURE__*/function (_Any) {
  _inherits(_class, _Any);

  var _super = _createSuper(_class);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this);
    _this._type = 'lazy';
    _this._flags.once = true;
    _this._cache = null;
    return _this;
  }

  _createClass(_class, [{
    key: "_init",
    value: function _init(fn, options) {
      return this.set(fn, options);
    }
  }, {
    key: "_base",
    value: function _base(value, state, options) {
      var schema;

      if (this._cache) {
        schema = this._cache;
      } else {
        var result = {
          value: value
        };
        var lazy = this._flags.lazy;

        if (!lazy) {
          result.errors = this.createError('lazy.base', null, state, options);
          return result;
        }

        schema = lazy();

        if (!(schema instanceof Any)) {
          result.errors = this.createError('lazy.schema', {
            schema: schema
          }, state, options);
          return result;
        }

        if (this._flags.once) {
          this._cache = schema;
        }
      }

      return schema._validate(value, state, options);
    }
  }, {
    key: "set",
    value: function set(fn, options) {
      Hoek.assert(typeof fn === 'function', 'You must provide a function as first argument');
      Hoek.assert(options === undefined || options && typeof options === 'object' && !Array.isArray(options), "Options must be an object");

      if (options) {
        var unknownOptions = Object.keys(options).filter(function (key) {
          return !['once'].includes(key);
        });
        Hoek.assert(unknownOptions.length === 0, "Options contain unknown keys: ".concat(unknownOptions));
        Hoek.assert(options.once === undefined || typeof options.once === 'boolean', 'Option "once" must be a boolean');
      }

      var obj = this.clone();
      obj._flags.lazy = fn;

      if (options && options.once !== obj._flags.once) {
        obj._flags.once = options.once;
      }

      return obj;
    }
  }]);

  return _class;
}(Any);

module.exports = new internals.Lazy();